import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import {
    ContentPlatformImage,
    ContentPlatformImageProps
} from "@/components/content-platform-image/src/content-platform-image";

export interface AgileAuthorProps {
    name?: string | null;
    biography?: string | null;
    pictureSrc?: string | null;
    contentType?: string;
}

export const AgileAuthor = ({
    name,
    biography,
    pictureSrc,
    contentType
}: AgileAuthorProps) => {
    if (!name || !biography || !pictureSrc) {
        return null;
    }
    const pictureProps: ContentPlatformImageProps = {
        src: pictureSrc,
        alt: name,
        baseWidth: 100,
        contentType: contentType
    };

    const containerCss = css({
        display: "flex",
        borderBlockStart: "solid 1px #dfe1e5",
        marginBlockStart: "25px",
        paddingBlockStart: "25px",

        [media.below.sm]: {
            flexFlow: "column",
            alignItems: "center",
            paddingInlineStart: "0px",
            textAlign: "center"
        }
    });

    const nameCss = css({
        fontSize: "1rem",
        paddingBlockEnd: "10px",
        textTransform: "uppercase",
        color: "#091e42"
    });

    const biographyCss = css({
        fontFamily: "var(--bxp-charlie-text-font-family)",
        fontSize: ".875rem !important",
        color: "#091e42",
        lineHeight: "1.5",
        marginBlockStart: "0px",
        marginBlockEnd: "24px",
        textAlign: "left"
    });

    const pictureCss = css({
        flexBasis: "100px",
        flexShrink: "0",
        width: "100px",
        height: "100px",
        marginBlockEnd: "16px",
        verticalAlign: "baseline"
    });

    return (
        <div css={containerCss}>
            <div css={pictureCss}>
                <ContentPlatformImage
                    {...pictureProps}
                    css={css({ maxWidth: "100%" })}
                />
            </div>
            <div
                css={css({
                    paddingInlineStart: "20px",
                    verticalAlign: "baseline",

                    [media.below.sm]: {
                        paddingInlineStart: "0px"
                    }
                })}
            >
                <span css={nameCss}>{name}</span>
                <p css={biographyCss}>{biography}</p>
            </div>
        </div>
    );
};
